import { Entry } from "contentful";
import { ContentBlock, Metadata } from "../models";

export const getURLToContentfulEntry = (entry: Entry<ContentBlock & Metadata>) => `https://app.contentful.com/spaces/${entry.sys.space?.sys.id || ''}/environments/${entry.sys.environment?.sys.id || ''}/entries/${entry.sys.id}`;
